import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import BASE_URL from "../../../config/config";
const CaseAdminCreate = () => {
  const [title, setTitle] = useState("");
  const [altText, setAltText] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [heading, setHeading] = useState(""); // NEW
  const [quillEntry, setQuillEntry] = useState("");
  const [quillEntries, setQuillEntries] = useState([]);
  const [savedData, setSavedData] = useState([]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleAddQuillEntry = () => {
    if (quillEntry.trim() !== "" && heading.trim() !== "") {
      setQuillEntries([...quillEntries, { heading, content: quillEntry }]);
      setQuillEntry("");
      setHeading(""); // reset heading
    }
  };

  // save the data here proper with profesionally
  const [openSaveSnackbar, setOpenSaveSnackbar] = useState(false);

  // const handleFinalSave = async () => {
  //   const token = localStorage.getItem("token");
  //   if (!title || !altText || !image || quillEntries.length === 0) {
  //     alert("Please fill all required fields.");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("title", title);
  //   formData.append("altText", altText);
  //   formData.append("image", image);
  //   formData.append("imagePreview", imagePreview);
  //   formData.append("quillEntries", JSON.stringify(quillEntries));

  //   try {
  //     const response = await fetch(`${BASE_URL}/case-studies`, {
  //       method: "POST",
  //       body: formData,
  //       headers: {
  //         Authorization: `Bearer ${token}`, // ✅ Proper placement
  //       },
  //     });

  //     if (response.ok) {
  //       const result = await response.json();
  //       console.log("Saved successfully:", result);

  //       setSavedData([
  //         ...savedData,
  //         { title, altText, imagePreview, image, quillEntries },
  //       ]);

  //       setTitle("");
  //       setAltText("");
  //       setImage(null);
  //       setImagePreview("");
  //       setQuillEntries([]);
  //       setOpenSaveSnackbar(true);
  //     } else {
  //       console.error("Failed to save:", response.statusText);
  //       alert("Something went wrong!");
  //     }
  //   } catch (err) {
  //     console.error("Error:", err);
  //     alert("Server error occurred!");
  //   }
  // };

  // get api
  const handleFinalSave = async () => {
    const token = localStorage.getItem("token");

    if (!title || !altText || quillEntries.length === 0) {
      alert("Please fill all required fields.");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("altText", altText);
    if (image) formData.append("image", image);
    formData.append("imagePreview", imagePreview);
    formData.append("quillEntries", JSON.stringify(quillEntries));

    try {
      const url = editingId
        ? `${BASE_URL}/case-studies/${editingId}`
        : `${BASE_URL}/case-studies`;

      const method = editingId ? "PATCH" : "POST";

      const response = await fetch(url, {
        method,
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Saved/Updated successfully:", result);

        if (editingId) {
          // Update existing record in state
          setSavedData((prev) =>
            prev.map((item) =>
              item.id === editingId
                ? { ...item, title, altText, imagePreview, quillEntries }
                : item
            )
          );
        } else {
          // Add new record
          setSavedData([
            ...savedData,
            { title, altText, imagePreview, image, quillEntries },
          ]);
        }

        // reset form
        setTitle("");
        setAltText("");
        setImage(null);
        setImagePreview("");
        setQuillEntries([]);
        setEditingId(null);
        setOpenSaveSnackbar(true);
      } else {
        console.error("Failed to save:", response.statusText);
        alert("Something went wrong!");
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Server error occurred!");
    }
  };

  useEffect(() => {
    const fetchCaseStudies = async () => {
      try {
        const res = await fetch(`${BASE_URL}/case-studies/list`);
        const data = await res.json();

        // ✅ Fix: set the actual array of case studies, not the entire response object
        if (Array.isArray(data.data)) {
          setSavedData(data.data);
        } else {
          console.warn("Expected array in data.data but got:", data);
          setSavedData([]);
        }
      } catch (err) {
        console.error("Failed to fetch case studies:", err);
        setSavedData([]); // Fallback to empty array
      }
    };

    fetchCaseStudies();
  }, []);
  // delet id
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [editingId, setEditingId] = useState(null);
  // const handleDelete = async (id) => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     const res = await fetch(`${BASE_URL}/case-studies/${id}`, {
  //       method: "DELETE",
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     if (res.ok) {
  //       setSavedData(savedData.filter((item) => item.id !== id));
  //       setOpenSnackbar(true);
  //     } else {
  //       console.error("Failed to delete");
  //     }
  //   } catch (err) {
  //     console.error("Error deleting case study:", err);
  //   }
  // };
  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${BASE_URL}/case-studies/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        setSavedData((prev) =>
          prev.filter((item) => item.id !== id && item._id !== id)
        );
        setOpenSnackbar(true);
      } else {
        console.error("Failed to delete");
      }
    } catch (err) {
      console.error("Error deleting case study:", err);
    }
  };

  // const handleEdit = (id) => {
  //   const dataToEdit = savedData.find((item) => item.id === id);
  //   if (dataToEdit) {
  //     setTitle(dataToEdit.title);
  //     setAltText(dataToEdit.altText);
  //     setImage(null); // If you want to re-upload image
  //     setImagePreview(dataToEdit.image);
  //     setQuillEntries(dataToEdit.quillEntries || []);
  //     setEditingId(id); // Use this in your save function to decide between POST or PUT
  //   }
  // };
  const handleEdit = (id) => {
    const dataToEdit = savedData.find(
      (item) => item.id === id || item._id === id
    );
    if (dataToEdit) {
      setTitle(dataToEdit.title || "");
      setAltText(dataToEdit.altText || "");
      setImage(null); // re-upload if needed
      setImagePreview(dataToEdit.imagePreview || dataToEdit.image || "");
      setQuillEntries(dataToEdit.quillEntries || []);
      setEditingId(id);
    }
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["blockquote"],
      ["link", "image"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "bullet",
    "indent",
    "align",
    "blockquote",
    "link",
    "image",
  ];
  // react quill data  delete logic

  const handleDeleteEntry = (index) => {
    const updatedEntries = [...quillEntries];
    updatedEntries.splice(index, 1);
    setQuillEntries(updatedEntries);
  };
  const IMAGE_BASE_URL = `${BASE_URL}/employees/view/`;

  return (
    <div className="w-full mx-auto overflow-x-scroll h-screen p-5 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-6">Create Case Study</h2>

      {/* Title */}
      <label className="block text-base font-medium mb-1">
        Case Study Title*
      </label>
      <span className=" text-red-500 text-sm">
        Note:- please dont use % in the title
      </span>
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value.toLowerCase())}
        placeholder="Enter title"
        className="w-full p-2 mb-4  border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
      />

      {/* Image Upload */}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Image Upload & Preview */}
        <div>
          <label className="block text-base font-medium mb-2">
            Image Upload
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
          />
          {imagePreview && (
            <img
              src={imagePreview}
              alt="Preview"
              className="mb-4 h-28 w-28 object-contain rounded shadow"
            />
          )}
        </div>

        {/* Alt Text */}
        <div>
          <label className="block text-base font-medium mb-2">Alt Text*</label>
          <input
            type="text"
            value={altText}
            onChange={(e) => setAltText(e.target.value)}
            placeholder="Image alt text"
            className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
          />
        </div>
      </div>

      <div className=" bg-gray-100 p-4">
        {/* NEW: Heading */}
        <label className="block text-base font-semibold mb-2">Heading *</label>
        <input
          type="text"
          value={heading}
          onChange={(e) => setHeading(e.target.value)}
          placeholder="Enter heading"
          className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
        />

        {/* Quill Text */}
        <label className="block text-base font-semibold mb-2">
          Description *
        </label>
        <ReactQuill
          theme="snow"
          value={quillEntry}
          onChange={setQuillEntry}
          className="mb-4"
          modules={quillModules}
          formats={quillFormats}
        />

        <button
          onClick={handleAddQuillEntry}
          className="bg-gray-700 text-white px-4 py-2 rounded hover:bg-gray-900 mb-6"
        >
          Add Block
        </button>

        {/* List of Added Quill Entries */}
      </div>

      {quillEntries.length > 0 && (
        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-2">Rich Text Blocks:</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 text-left text-sm">
              <thead className="bg-gray-200">
                <tr>
                  <th className="px-4 py-2 border border-gray-300">#</th>
                  <th className="px-4 py-2 border border-gray-300">Heading</th>
                  <th className="px-4 py-2 border border-gray-300">
                    Description
                  </th>
                  <th className="px-4 py-2 border border-gray-300">Action</th>
                </tr>
              </thead>
              <tbody>
                {quillEntries.map((entry, index) => (
                  <tr key={index} className="bg-white">
                    <td className="px-4 py-2 border border-gray-300">
                      {index + 1}
                    </td>
                    <td className="px-4 py-2 border border-gray-300">
                      {entry.heading}
                    </td>
                    <td
                      className="px-4 py-2 border border-gray-300"
                      dangerouslySetInnerHTML={{ __html: entry.content }}
                    />
                    <td className="px-4 py-2 border border-gray-300">
                      <button
                        onClick={() => handleDeleteEntry(index)}
                        className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <button
        onClick={handleFinalSave}
        className="w-full bg-main1 mt-4 text-white px-4 py-2 rounded hover:bg-green-700"
      >
        Save Case Study
      </button>

      {/* Table of Saved Entries */}
      <div className="mt-8">
        <h3 className="text-xl font-bold mb-4">Saved Case Studies</h3>
        {savedData.length === 0 ? (
          <p className="text-gray-600">There are no case studies.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white text-center border">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-2 border">Title</th>
                  <th className="px-4 py-2 border">Image</th>
                  <th className="px-4 py-2 border">Action</th>
                </tr>
              </thead>
              <tbody>
                {savedData?.map((data, index) => (
                  <tr key={data.id || index}>
                    <td className="px-4 py-2 border">{data.title}</td>
                    <td className="px-4 py-2 border flex justify-center items-center">
                      {data.imagePreview && (
                        <img
                          // src={data.imagePreview}
                          src={
                            data?.imagePreview
                              ? `${IMAGE_BASE_URL}${data?.imagePreview}`
                              : "/image/default.png"
                          }
                          alt={data.altText}
                          className="h-16 w-20 object-contain rounded"
                        />
                      )}
                    </td>
                    <td className="px-4 py-2 border">
                      <button
                        onClick={() => handleDelete(data.id)}
                        className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 mr-2"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>

                      <button
                        onClick={() => handleEdit(data.id)}
                        className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                      >
                        <FontAwesomeIcon icon={faPenSquare} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          Deleted successfully!
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSaveSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSaveSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSaveSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Saved successfully!
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CaseAdminCreate;
